import { render, staticRenderFns } from "./PermissionList.vue?vue&type=template&id=3d9c2f06&scoped=true"
import script from "./PermissionList.vue?vue&type=script&lang=js"
export * from "./PermissionList.vue?vue&type=script&lang=js"
import style0 from "./PermissionList.vue?vue&type=style&index=0&id=3d9c2f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c2f06",
  null
  
)

export default component.exports